// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3QEf0","imageUploader":"EGiftCard_imageUploader__14VWj"};